import { z } from 'zod';

// The workflow config's `actions` is a JSON blob keyed by action key, and each
// entry carries the icon the rest of the app already draws for that action.
const workflowActionsSchema = z.record(
  z.string(),
  z.object({ icon: z.string().min(1).optional() }).passthrough()
);

export function actionIconsOf(actions: unknown): Record<string, string> {
  const parsed = workflowActionsSchema.safeParse(actions);
  if (!parsed.success) {
    return {};
  }
  const icons: Record<string, string> = {};
  for (const [key, action] of Object.entries(parsed.data)) {
    if (action.icon) {
      icons[key] = action.icon;
    }
  }
  return icons;
}
